// vue-svg-sprite directive — used as `<svg v-svg-sprite="'icon-foo'" />`.
// The sprite itself is injected into <body> by vite-plugin-svg-icons via
// the `import 'virtual:svg-icons-register'` line in each entry.
export { svgSpriteDirectivePlugin } from 'vue-svg-sprite'
